var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_448_5214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.375 4.6875V0.78125",
    stroke: "white",
    strokeWidth: 1.5625,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M9.375 17.9688V14.0625",
    stroke: "white",
    strokeWidth: 1.5625,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.917,
    d: "M7.03125 5.25781L5.07812 1.875",
    stroke: "white",
    strokeWidth: 1.5625,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.417,
    d: "M13.6719 16.8174L11.7188 13.4346",
    stroke: "white",
    strokeWidth: 1.5625,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.833,
    d: "M5.31543 7.03125L1.93262 5.07812",
    stroke: "white",
    strokeWidth: 1.5625,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.333,
    d: "M16.8174 13.6719L13.4346 11.7188",
    stroke: "white",
    strokeWidth: 1.5625,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M4.6875 9.375H0.78125",
    stroke: "white",
    strokeWidth: 1.5625,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M17.9688 9.375H14.0625",
    stroke: "white",
    strokeWidth: 1.5625,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.667,
    d: "M5.31543 11.7188L1.93262 13.6719",
    stroke: "white",
    strokeWidth: 1.5625,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.167,
    d: "M16.8174 5.07812L13.4346 7.03125",
    stroke: "white",
    strokeWidth: 1.5625,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.583,
    d: "M7.03125 13.4346L5.07812 16.8174",
    stroke: "white",
    strokeWidth: 1.5625,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.083,
    d: "M13.6719 1.93262L11.7188 5.31543",
    stroke: "white",
    strokeWidth: 1.5625,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_448_5214"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.75,
    height: 18.75,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.233082c418fe00c44c2c4f0c95b9792a.svg";
export { ForwardRef as ReactComponent };